import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: hidden;

  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  row-gap: 24px;

  background-color: ${(props) => props.theme.colors.greys.lighter};
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: calc(100% - 48px);

  padding-bottom: 8px;

  background: ${(props) => props.theme.colors.greys.lighter};
`;

export const SidePaddedGapContainer = styled.div`
  width: 100%;
  padding: 0 24px;
`;

export const FlexedGapContainer = styled.div`
  display: flex;
  column-gap: 24px;
`;

export const ListContainer = styled.div`
  height: 100%;
  width: 100%;

  position: relative;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: end;
`;

export const InfoBoxContainer = styled.div`
  color: ${(props) => props.theme.colors?.greys?.darker};
  font: ${(props) => props.theme.fonts.textSmall};

  > .kpi {
    color: ${(props) => props.theme.colors?.greys?.darkest};
    font: ${(props) => props.theme.fonts?.kpiSmall};
  }
`;

export const InfoBoxLabel = styled.div`
  display: flex;
  flex-direction: row;
`;
